export default function ExitScreenModal({ navigate, onClose }) {
  return (
    <div
      className="exit-confirm-overlay fixed inset-0 z-40 flex items-center justify-center bg-black/55 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="exit-confirm-title"
      aria-describedby="exit-confirm-description"
    >
      <div className="exit-confirm-card w-full max-w-xl rounded-[2rem] border-4 border-[#0B2B66] bg-[#FFF8E8] p-8 text-center font-mali shadow-[0_24px_60px_rgba(7,23,51,0.4)]">
        <h2
          id="exit-confirm-title"
          className="exit-confirm-title text-3xl font-extrabold text-[#0B2B66]"
        >
          Are you sure you want to exit?
        </h2>
        <p
          id="exit-confirm-description"
          className="exit-confirm-description mt-4 text-lg font-semibold leading-7 text-[#5C4A2A]"
        >
          If you leave now, your current assessment question will not be
          completed.
        </p>
        <div className="exit-confirm-actions mt-8 flex justify-center gap-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="exit-confirm-button rounded-xl border-2 border-[#0B2B66] bg-gradient-to-r from-[#FFF27A] via-[#FFBE4D] to-[#FF8F1F] px-6 py-3 text-lg font-bold text-[#0B2B66] shadow-[0_4px_0_#0B2B66]"
          >
            Yes, exit
          </button>
          <button
            type="button"
            onClick={onClose}
            className="exit-confirm-button rounded-xl border-2 border-[#0B2B66] bg-white px-6 py-3 text-lg font-bold text-[#0B2B66]"
          >
            Stay here
          </button>
        </div>
      </div>
    </div>
  );
}
